export default __webpack_public_path__ + "static/media/AvenirNext-DemiBoldItalic.6cff52c2.woff";